import React, { Component } from 'react';
import _ from 'lodash';

import IntelliportSensorsTable from '../components/IntelliportSensorsTable';
import IntelliportSensorsSettingsForm from '../components/IntelliportSensorsSettingsForm';
import IntelliportSensorsModel from '../components/IntelliportSensorsModel';

import UserModel from '../components/UserModel';

import { Layout, Button, Row, Col, Input, Icon, Switch, Modal, message } from 'antd';
import IntelliportSensorsParkinglocationsSelect from '../components/IntelliportSensorsParkinglocationsSelect';

class IntelliportSensorsScreen extends Component {

  state = {
    autoReload: (localStorage.getItem('table_autoReload') !== undefined && localStorage.getItem('table_autoReload') == 'true') ? true : false,
    dataLoading: true,
    dataAll: [],
    data: [],
    searchedTextValue: "",
    parkingLocationId: null,
    IntelliportSensorsSettingsFormModalVisible: false,
    mapModalVisible: false,
  }

  intervalId = null;

  componentWillMount() {
    this.loadData(this.state.parkingLocationId);

    // Checking auto reload data
    this.intervalId = setInterval(() => {
      if (this.state.autoReload) {
        this.loadData(this.state.parkingLocationId);;
      }
    }, 30000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  loadData(parkingLocationId) {
    this.setState({
      dataLoading: true
    });
    IntelliportSensorsModel.getAll(parkingLocationId)
      .then(data => {
        this.setState({
          dataLoading: false,
          dataAll: data,
          data: data
        });
      })
      .catch(() => {
        message.warning('Data se nepodařilo načíst. Zkontrolujte spravnou funkčnost služby.')
        this.setState({
          dataLoading: false,
        });
      })
      .then(() => {
        if (this.state.searchedTextValue) {
            this.onSearchDescription(this.state.searchedTextValue);
        }
    })
  }

  onSearchDescription(searchText) {
    const dataAll = this.state.dataAll;
    this.setState({
      data: _.filter(dataAll, (d) => {
        if (typeof (d['serial_number']) != 'undefined') {
          return d['serial_number'].toLowerCase().includes(searchText.toLowerCase());
        } else {
          return dataAll
        }
        if (searchText == '') {
          return dataAll
        }
      })
    });
  }

  render() {
    return (
      <Layout.Content style={{ margin: '24px 16px 0', minHeight: 'auto' }}>
        <div style={{ padding: 24, background: '#fff' }}>
          <h2>Intelliport - Senzory</h2>
          <div style={{ marginBottom: '20px' }}>
            <Row>
              <Col span={8}>
                <IntelliportSensorsParkinglocationsSelect
                  allowClear={true}
                  onChange={(value) => {
                    this.loadData(value);
                    this.setState({ searchedTextValue: "", parkingLocationId: value })
                  }}
                  style={{ width: 300 }}
                />
                <Input.Search
                  placeholder="Najít podle sériového čísla"
                  value={this.state.searchedTextValue}
                  onSearch={this.onSearchDescription.bind(this)}
                  onChange={(e) => {
                    this.setState({
                      searchedTextValue: e.target.value
                    })
                  }}
                  style={{ width: 300 }} />
              </Col>
              <Col span={10} offset={6} style={{ textAlign: 'right' }}>
                <Switch
                  checked={this.state.autoReload}
                  onChange={(checked) => {
                    localStorage.setItem('table_autoReload', checked);
                    this.setState({
                      autoReload: checked
                    });
                  }} /> Automatická obnova
                <Button type="default" onClick={() => { this.loadData(this.state.parkingLocationId) }} style={{ marginRight: 10, marginLeft: 15 }}><Icon type="sync" /></Button>
                {this.state.parkingLocationId
                  &&
                  <Button
                    type="default"
                    onClick={() => {
                      this.setState({ mapModalVisible: true })
                    }}
                    style={{ marginRight: 10, marginLeft: 10 }}>
                    <Icon type="environment" /> Mapa
                  </Button>
                }
                {UserModel.isInRoles(['ADMIN', 'INTELLIPORT_SENSORS_WRITE'])
                  ? <Button type="default" onClick={() => { this.setState({ intelliportSensorsSettingsFormModalVisible: true }) }}>Nový senzor</Button>
                  : null}
              </Col>
            </Row>
          </div>
          <IntelliportSensorsSettingsForm
            type="modal"
            modalVisible={this.state.intelliportSensorsSettingsFormModalVisible}
            onModalCancel={(form) => {
              form.resetFields();
              this.setState({ intelliportSensorsSettingsFormModalVisible: false })
            }}
            onSuccess={(form, values) => {
              IntelliportSensorsModel.create(values)
                .then(() => {
                  form.resetFields();
                  message.success("Senzor byl vložen!");
                  this.setState({ intelliportSensorsSettingsFormModalVisible: false });
                  this.loadData(this.state.parkingLocationId);
                })
                .catch((err) => {
                  message.warning('Data se nepodařilo uložit. Prosím kontaktujte správce systému!');
                });
            }} />

          <IntelliportSensorsTable
            data={this.state.data}
            loading={this.state.dataLoading}
            onRowRemoved={() => {
              this.loadData(this.state.parkingLocationId);
            }}
            onAnyFormSuccess={() => {
              this.loadData(this.state.parkingLocationId);
            }} />
        </div>
      </Layout.Content>
    );
  }
}

export default IntelliportSensorsScreen;



// WEBPACK FOOTER //
// ./src/screens/IntelliportSensorsScreen.js